<template>
<div class="OrderView box-shadow bgc">
    <div class="orderbaseinfo">
        <div class="userinfo">
            <img class="img" :src="item.eventvoucherinfo.userlogo" alt="">
            <span>{{item.eventvoucherinfo.username}}</span>
        </div>
        <div class="box">
            <div class="innerbox"><span class="name">活动名称：</span><span class="value">{{item.eventinfo.eventname}}</span></div>
            <div class="innerbox"><span class="name">订单号：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.voucherid}}</span></div>
            <div class="innerbox"><span class="name">订单状态：</span><span class="value" :class="status(item.eventvoucherinfo.status)">{{item.eventvoucherinfo.statusname}}</span></div>
            <div class="innerbox"><span class="name">订单时间：</span><span class="value">{{item.eventvoucherinfo.datetime}}</span></div>
            <div class="innerbox"><span class="name">活动类型：</span><span class="value">{{item.eventinfo.eventtypename}}</span></div>
            <div class="innerbox"><span class="name">商家名称：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.rolehostname}}</span></div>
            <div class="innerbox"><span class="name">订单金额：</span><span class="value">￥{{item.eventvoucherinfo.ordermoney}}</span></div>
            <div class="innerbox" v-if="item.eventvoucherinfo.commonsaleinfo.checktime"><span class="name">核销时间：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.checktime}}</span></div>
        </div>
        <div class="box">
            <div class="innerbox"><span class="name">商品佣金：</span><span class="value tc-orange">￥{{item.eventvoucherinfo.brokerageproduct}}</span></div>
            <div class="innerbox"><span class="name">团长佣金：</span><span class="value tc-orange">￥{{item.eventvoucherinfo.brokeragebyheader}}</span></div>
            <div class="innerbox" v-if="item.eventinfo.isdisevent"><span class="name">分销员：</span><span class="value">{{item.eventvoucherinfo.parentusername}}</span></div>
            <div class="innerbox" v-if="item.eventinfo.isdisevent"><span class="name">分销佣金：</span><span class="value tc-orange">￥{{item.eventvoucherinfo.parentusermoney}}</span></div>
        </div>
        <div class="box" v-if="item.eventvoucherinfo.commonsaleinfo.shipname">
            <div class="innerbox"><span class="name">收货姓名：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.shipname}}</span></div>
            <div class="innerbox"><span class="name">收货地址：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.shipaddress}}</span></div>
            <div class="innerbox"><span class="name">收货电话：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.shiptel}}</span></div>
            <div class="innerbox">
                <el-button type="text" size="mini" v-clipboard:copy="linkinfo" v-clipboard:success="onCopy" v-clipboard:error="onError" class="name icon icon_bb_copy">复制收货信息</el-button>
            </div>
            <div class="innerbox" v-if="item.eventvoucherinfo.commonsaleinfo.shipno"><span class="name">快递单号：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.shipno}}</span></div>
            <div class="innerbox" v-if="item.eventvoucherinfo.commonsaleinfo.shipno"><span class="name">快递公司：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.shipcompanyname}}</span></div>
            <div class="innerbox" v-if="item.eventvoucherinfo.commonsaleinfo.shipno"></div>
            <div class="innerbox" v-if="item.eventvoucherinfo.commonsaleinfo.shipno">
                <el-button type="text" size="mini" v-clipboard:copy="shipinfo" v-clipboard:success="onCopy" v-clipboard:error="onError" class="name icon icon_bb_copy">复制物流信息</el-button>
            </div>
        </div>
        <div class="box" v-if="item.eventvoucherinfo.commonsaleinfo.name">
            <div class="innerbox"><span class="name">提货点名称：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.ppname}}</span></div>
            <div class="innerbox"><span class="name">联系人：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.pplinkman}}</span></div>
            <div class="innerbox"><span class="name">联系方式：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.pplinktel}}</span></div>
            <div class="innerbox">
                <el-button type="text" size="mini" v-clipboard:copy="takeinfo" v-clipboard:success="onCopy" v-clipboard:error="onError" class="name icon icon_bb_copy">复制收货信息</el-button>
            </div>
            <div class="innerbox"><span class="name">提货点地址：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.ppaddress}}</span></div>
        </div>
        <div class="box" v-if="item.eventvoucherinfo.commonsaleinfo.refundtime">
            <div class="innerbox"><span class="name">退款申请时间：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.refundtime}}</span></div>
            <div class="innerbox"><span class="name">退款说明：</span><span class="value">{{item.eventvoucherinfo.commonsaleinfo.refundmemo}}</span></div>
        </div>
        <div class="box">
            <div class="innerbox"><span class="name">备注：</span><span class="value">{{item.eventvoucherinfo.memo}}</span></div>
        </div>
    </div>
    <div class="orderotherinfo">
        <el-tabs v-model="activeName">
            <el-tab-pane label="商品详情" name="0">
                <el-table :data="item.eventvoucherinfo.commonsaleinfo.productlist" style="width: 100%">
                    <el-table-column prop="subject" label="商品名称" min-width="250px" class-name="title">
                        <template slot-scope="scope">
                            <div class="imageText">
                                <img class="img" v-lazy="scope.row.coveratturlid " :alt="scope.row.productname"
                                     preview="product">
                                <span>{{scope.row.productname}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleprice " label="商品单价" class-name="center">
                        <template slot-scope="scope">￥{{scope.row.saleprice}}</template>
                    </el-table-column>
                    <el-table-column prop="productcount" label="商品数量" class-name="center">
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="参与表单" name="1">
                <div class="box" v-for="(obj, index) in item.joinerlist" :key="index">
                    <div class="innerbox" v-for="(obj2, idx) in obj.formdatalist" :key="idx">
                        <span class="name">{{obj2.formname}}：</span>
                        <span class="value">{{obj2.formvalue}}</span>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
    <div class="btns" v-if="[98,32,31].indexOf(item.eventvoucherinfo.status)>-1">
        <el-button type="primary" plain @click="handleRefundReject" v-if="item.eventvoucherinfo.status==98">拒绝退款</el-button>
        <el-button type="primary" @click="handleRefund" v-if="item.eventvoucherinfo.status==98">确认退款</el-button>
        <el-button type="primary" @click="handleShip" v-if="item.eventvoucherinfo.status==32">确认发货</el-button>
        <el-button type="primary" @click="handleWriteoff" v-if="item.eventvoucherinfo.status==31">确认核销</el-button>
    </div>
    <shipDialog ref="shipDialog" @refresh="refresh"></shipDialog>
    <refundDialog ref="refundDialog" @refresh="refresh"></refundDialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getOrderDetail, uploadRefundOrderResult, uploadOrderCheckResult} from 'api/brandBusiness'
import {brandBusiness} from 'api/enumCode'
import ShipDialog from 'views/brandBusiness/activityMgt/order/components/shipDialog.vue'
import RefundDialog from 'views/brandBusiness/activityMgt/refund/components/refundDialog.vue'
export default {
    name: 'OrderView',
    data() {
        return {
            param: {
                orderno: this.$route.query.orderno ? this.$route.query.orderno : '',
                eventid: this.$route.query.eventid ? this.$route.query.eventid : ''
            },
            item : {
                eventinfo: {},
                eventvoucherinfo: {
                    commonsaleinfo: {
                        productlist: []
                    },
                },
                joinerlist: [
                    {
                        formdatalist: []
                    }
                ]
            },
            shipinfo: '',
            linkinfo: '',
            takeinfo: '',
            activeName: ''
        }
    },
    mounted() {
        this._getView()
    },
    methods: {
        refresh() {
            this.setIsRefresh(1)
            this._getView()
        },
        handleRefundReject() {
            let obj = {
                refundmemo: '',
                status: 1,
                eventtype: 10,
                orderno: this.item.eventvoucherinfo.commonsaleinfo.voucherid
            }
            this.$refs.refundDialog.openDialog(obj)
        },
        handleRefund() {
            this.$confirm(`<span class="tc-black">确认退款</span>￥${this.item.orderinfo.ordermoney}`, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确认退款',
                showCancelButton: false
            }).then(() => {
                let obj = {
                    refundmemo: '',
                    status: 1,
                    eventtype: 10,
                    orderno: this.item.eventvoucherinfo.commonsaleinfo.voucherid
                }
                this._refund(obj)
            })
        },
        handleShip() {
            this.$refs.shipDialog.openDialog({type: 2, orderno: [this.item.eventvoucherinfo.commonsaleinfo.voucherid]})
        },
        handleWriteoff() {
            this.$confirm(`确认核销该订单`, '提示', {
                confirmButtonText: '确认核销',
                showCancelButton: false
            }).then(() => {
                let obj = {
                    checkusertype: 1,
                    eventtype: 10,
                    orderno: this.item.eventvoucherinfo.commonsaleinfo.voucherid
                }
                this._writeoff(obj)
            })
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
        _writeoff(obj) {
            this.setLoading(true)
            uploadOrderCheckResult({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('核销成功')
                    this.setIsRefresh(1)
                    this._getView()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _refund(obj) {
            this.setLoading(true)
            uploadRefundOrderResult({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('退款成功')
                    this.setIsRefresh(1)
                    this._getView()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getOrderDetail({
                data: Object.assign({}, this.param),
                success: data => {
                    this.item = data.data
                    this.linkinfo = `收货姓名：${this.item.eventvoucherinfo.commonsaleinfo.shipname} 收货电话：${this.item.eventvoucherinfo.commonsaleinfo.shiptel} 收货地址：${this.item.eventvoucherinfo.commonsaleinfo.shipaddress}`
                    this.shipinfo = `快递公司：${this.item.eventvoucherinfo.commonsaleinfo.shipcompanyname} 快递单号：${this.item.eventvoucherinfo.commonsaleinfo.shipno}`
                    this.takeinfo = `提货点名称：${this.item.eventvoucherinfo.commonsaleinfo.ppname} 联系人：${this.item.eventvoucherinfo.commonsaleinfo.pplinkman} 联系方式：${this.item.eventvoucherinfo.commonsaleinfo.pplinktel}  提货点地址：${this.item.eventvoucherinfo.commonsaleinfo.ppaddress}`
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading', 'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        status() {
            return function (value) {
                for (let i = 0; i < brandBusiness.orderStatus.length; i++) {
                    if (value === brandBusiness.orderStatus[i].code) {
                        return brandBusiness.orderStatus[i].cls
                    }
                }
                return value
            }
        }
    },
    components: {
        ShipDialog, RefundDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.OrderView {
    color: #303133;
    font-size: 14px;
    .orderbaseinfo{
        padding: 20px;
        .userinfo{
            display: flex;
            align-items: center;
            .img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .box{
            display: flex;
            flex-wrap: wrap;
            padding-top: 20px;
            .innerbox{
                width: 25%;
                margin-bottom: 20px;
                display:flex;
                align-items: center;
                .name{
                    color: #606266;
                    display:flex;
                    align-items: center;
                    min-width: 72px;
                }
                .icon_bb_copy:before{
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                }
                .el-button, .el-button--mini{
                    height: auto;
                }
            }
        }
        .box+.box{
            border-top: 1px solid #DCDFE6 ;
        }
    }
    .orderotherinfo{
       padding: 0 20px;
        .imageText{
            display: flex;
            .img{
                height: 60px;
                width: 60px;
                margin-right: 12px;
            }
        }
        .innerbox{
            margin-bottom: 20px;
            display:flex;
            align-items: center;
            .name{
                color: #606266;
            }
        }
    }
    .btns{
        height: 74px;
        margin-top: 30px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
